export default defineNuxtPlugin(() => {
    const config = useRuntimeConfig();

    if (config.public.env === 'staging' || config.public.env === 'production') {
        // Create and append autoblocker script
        // const autoblockerScript = document.createElement('script');
        // autoblockerScript.src = 'https://web.cmp.usercentrics.eu/modules/autoblocker.js';
        // document.head.appendChild(autoblockerScript);

        // Create and append usercentrics CMP loader script
        const usercentricsScript = document.createElement('script');
        usercentricsScript.src = 'https://web.cmp.usercentrics.eu/ui/loader.js';
        usercentricsScript.setAttribute('async', 'true');
        usercentricsScript.setAttribute('data-settings-id', '0KvJM9LtPYMVCj');
        usercentricsScript.setAttribute('id', 'usercentrics-cmp');
        document.head.appendChild(usercentricsScript);
    }
});
